<div class="mx-auto w-full max-w-4xl px-4 py-8 md:px-6">
  <!-- Premium Glassmorphic Header -->
  <div
    class="surface-default border border-neutral-a3 rounded-2xl p-6 mb-8 backdrop-blur-md shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4"
  >
    <div class="flex items-center gap-x-4">
      <button
        mat-icon-button
        (click)="goBack()"
        aria-label="Retour"
        class="hover:bg-neutral-a2 transition-colors"
      >
        <mat-icon svgIcon="arrow-left" class="size-5"></mat-icon>
      </button>
      <div>
        <h1 class="text-2xl font-bold tracking-tight text-default flex items-center gap-x-3">
          Vos notifications
          @if (state.unreadCount() > 0) {
            <span
              class="inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-semibold text-primary"
            >
              {{ state.unreadCount() }} non lues
            </span>
          }
        </h1>
        <p class="text-sm text-muted mt-1">Gérez et consultez vos alertes en temps réel.</p>
      </div>
    </div>

    @if (state.unreadCount() > 0) {
      <button
        mat-button
        class="secondary text-sm font-medium self-start md:self-auto hover:bg-neutral-a2 transition-all"
        (click)="markAllAsRead()"
      >
        <mat-icon svgIcon="check-check" class="size-4 mr-2"></mat-icon>
        Tout marquer comme lu
      </button>
    }
  </div>

  <!-- Filters Bar -->
  <div class="flex items-center gap-x-2 mb-6">
    <div class="inline-flex rounded-xl p-1 bg-neutral-a2 border border-neutral-a3 gap-2">
      <button
        mat-button
        class="px-4 py-1.5 text-xs font-semibold transition-all hover:bg-neutral-a3"
        [class.bg-neutral-a4]="filter() === 'all'"
        [class.text-default]="filter() === 'all'"
        [class.text-muted]="filter() !== 'all'"
        (click)="setFilter('all')"
      >
        Toutes
      </button>
      <button
        mat-button
        class="px-4 py-1.5 text-xs font-semibold transition-all hover:bg-neutral-a3"
        [class.bg-neutral-a4]="filter() === 'unread'"
        [class.text-default]="filter() === 'unread'"
        [class.text-muted]="filter() !== 'unread'"
        (click)="setFilter('unread')"
      >
        Non lues
      </button>
    </div>
  </div>

  <!-- Notifications List -->
  <div class="flex flex-col gap-y-4">
    @if (notifications().length === 0 && !loading()) {
      <div
        class="surface-default border border-neutral-a3 rounded-2xl p-12 text-center flex flex-col items-center justify-center gap-y-4 shadow-sm"
      >
        <div class="flex size-14 items-center justify-center rounded-full bg-neutral-a2">
          <mat-icon svgIcon="bell-off" class="text-neutral-8 size-7"></mat-icon>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-default">Aucune notification</h3>
          <p class="text-sm text-muted mt-1">
            Vous êtes à jour ! Aucune notification à afficher pour le moment.
          </p>
        </div>
      </div>
    } @else {
      @for (n of notifications(); track n._id) {
        <div
          class="surface-default border border-neutral-a3 border-l-4 rounded-xl p-5 shadow-sm transition-all hover:translate-y-[-2px] hover:shadow-md flex items-start gap-x-4"
          [class]="getBorderColorClass(n.type)"
          [class.bg-neutral-a1]="!n.read"
        >
          <!-- Accent Colored Icon -->
          <div
            class="flex size-10 shrink-0 items-center justify-center rounded-full shadow-sm"
            [class]="getIconColorClass(n.type)"
          >
            <mat-icon [svgIcon]="getIconName(n.type)" class="size-5"></mat-icon>
          </div>

          <!-- Content and Info -->
          <div class="flex-1 min-w-0">
            <div class="flex items-start justify-between gap-x-4">
              <h3 class="text-sm font-semibold text-default break-words" [class.font-bold]="!n.read">
                {{ n.title }}
              </h3>
              <span class="text-xs text-muted-more shrink-0 font-medium">
                {{ formatTime(n.createdAt) }}
              </span>
            </div>
            <p class="text-sm text-muted mt-1 leading-relaxed break-words">
              {{ n.message }}
            </p>
          </div>

          <!-- Action Buttons (Mark as read) -->
          @if (!n.read) {
            <button
              mat-icon-button
              class="shrink-0 hover:bg-neutral-a2 text-primary transition-all"
              (click)="markAsRead(n._id)"
              aria-label="Marquer comme lu"
              title="Marquer comme lu"
            >
              <mat-icon svgIcon="check" class="size-5"></mat-icon>
            </button>
          }
        </div>
      }

      <!-- Loading State / Spinner -->
      @if (loading()) {
        <div class="flex justify-center items-center py-6">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      }

      <!-- Load More Button -->
      @if (hasMore() && !loading()) {
        <button
          mat-button
          class="primary w-full py-3 rounded-xl hover:shadow-lg transition-all mt-4 font-semibold text-sm flex items-center justify-center gap-x-2"
          (click)="loadNextPage()"
        >
          <mat-icon svgIcon="chevron-down" class="size-5"></mat-icon>
          Charger plus
        </button>
      }
    }
  </div>
</div>
